<template>
  <aside class="pageContent__steps-aside">
      <div class="croppedDiv__re-transform-aside pageContent-aside-main pageContent-aside-main-rightGray">
          <div class="croppedDiv__re-transform steps__aside">
              <div class="steps__aside--item">
                  <div class="steps__item steps__item--current"><span>1.</span></div>
                  <p>Vyplňte už jen pár údajů, abychom se s&nbsp;vámi mohli spojit</p>
              </div>
              <div class="steps__aside--item">
                  <div class="steps__item steps__item--prev"><span>2.</span></div>
                  <p>Brzy po odeslání se vám ozvou kolegové z&nbsp;portálu NejŘemeslníci.cz a&nbsp;poradí vám s&nbsp;detaily poptávky.</p>
              </div>
              <div class="steps__aside--item">
                  <div class="steps__item steps__item--prev"><span>3.</span></div>
                  <p>Pak už můžete jen vybírat z&nbsp;konkrétních nabídek od prověřených řemeslníků.</p>
              </div>
              <p>Nabídky prověřených řemeslníků obdržíte díky naší spolupráci s&nbsp;portálem <a href="https://www.nejremeslnici.cz/" style="color: #0070ff; font-weight: 300; text-decoration: underline;" target="_blank">NejŘemeslníci.cz</a></p>
              <img src="/wp-content/themes/rigips/images/nejremeslnici-logo-blue.svg" width="184" alt="Nejřemeslníci logo">
          </div>
      </div>
  </aside>
</template>

<script>
  export default {
    name: 'CalculationAsideSteps',
  }
</script>



// WEBPACK FOOTER //
// src/components/calculation/calculator/construction/aside/AsideSteps.vue